export default __webpack_public_path__ + "img/btn-save.29127388.svg";